import { render } from "./WorkoutSummary.vue?vue&type=template&id=6dfcde65&scoped=true"
import script from "./WorkoutSummary.vue?vue&type=script&lang=js"
export * from "./WorkoutSummary.vue?vue&type=script&lang=js"

import "./WorkoutSummary.vue?vue&type=style&index=0&id=6dfcde65&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfcde65"]])

export default __exports__